const SplitTestConstants = {
  ZRM_AI_LISTING_CREATION: 'zrm_ai_listing_creation',
  ZRM_FLEXIBLE_PROPERTY_CREATION: 'zrm_flexible_property_creation',
} as const;

export default SplitTestConstants;
